if (!customElements.get('menu-drawer')) {
  class MenuDrawer extends HTMLElement {
    static observedAttributes = ['hold'];

    constructor() {
      super(); 
    }

    attributeChangedCallback() {
      this.connectedCallback();
    }

    connectedCallback() {
      if(this.getAttribute('data-hold')) return;
      
      this.mainDetailsToggle = this.querySelector('details');
      this.buttonBack = document.querySelector('.js-menu-drawer-back');
      this.modalOverlay = document.querySelector('.modal-overlay');
      this.menuDrawer = document.querySelector('#menu-drawer');
      this.inner = document.querySelector('.mobile-facets__inner');

      // if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

      this.addEventListener('keyup', this.onKeyUp.bind(this));
      // this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button').forEach(button => {
        if(button.classList.contains('disclosure__button')) return;

        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      });
      this.modalOverlay.addEventListener('click', this.onModalOverlayClick.bind(this));
      this.buttonBack.addEventListener('click', this.closeMenuDrawer.bind(this));
    }

    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;

      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
      const parentDetails = event.target.closest('details');
      const summaryElement = parentDetails.classList.contains('menu-drawer-container') ? this.querySelector('summary') : parentDetails.querySelector('summary');
      const detailsElement = summaryElement.parentNode;

      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }

      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }

    onModalOverlayClick(event) {
      this.closeMenuDrawer(event);
    }

    openMenuDrawer(summaryElement) {
      if(this.inner) {
        this.inner.removeEventListener('transitionend', this.onCloseTransitionend);
      }
      
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      
      themeBase.freezeScroll({
        breakpoint: this.dataset.breakpoint,
        additionalClass: 'body-menu-opening'
      });
    }

    onCloseTransitionend() {
      document.body.classList.remove('body-menu-opening');
    }

    closeMenuDrawer(event, elementToFocus = false) {
      if (event !== undefined) {
        if(this.inner) {
          this.inner.removeEventListener('transitionend', this.onCloseTransitionend);
          this.inner.addEventListener('transitionend', this.onCloseTransitionend, { once: true });
        }

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
      }
      themeBase.unfreezeScroll();
    }

    // onFocusOut(event) {
    //   setTimeout(() => {
    //     if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer(event);
    //   });
    // }

    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details') || this.querySelector('details');
      const summaryElement = detailsElement.querySelector('summary');
      
      summaryElement.focus();
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus();
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }

      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define('menu-drawer', MenuDrawer);
  
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
  
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.getElementById('shopify-section-header');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      }, 10);
  
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      themeBase.freezeScroll({
        breakpoint: this.dataset.breakpoint
      });
    }
  }
  
  customElements.define('header-drawer', HeaderDrawer);

  scriptController.scripts.push('menu-drawer.js');
}